export default __webpack_public_path__ + "static/media/TestPlan.6ac08bbb.svg";